import { useEffect, useState } from 'react'
import { Box, Grid } from '@material-ui/core'
import { MainContainer } from 'components/page/containers/MainContainer'
import { useJobsFeed } from 'hooks/use-jobs-feed/useJobsFeed'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAuth } from 'pages/auth/hooks/useAuth'
import InfiniteScroll from 'react-infinite-scroll-component'
import MiniJobCard from './components/MiniJobCard'
import SearchInput from './components/SearchInput'
import {
  PrivateJobContainer,
  PrivateJobHeader,
  PrivateJobLeftContainer,
  PrivateJobMain,
  PrivateJobRightContainer,
  PrivateJobTitle,
  PrivateJobMiddleContainer,
  PrivateJobTitleInner
} from './styles'
import { Loader } from 'components/core/loader'

import { useTheme } from 'styled-components'
import FilterButton from './components/FilterButton'
import { ArrowBack } from '@material-ui/icons'
import { NavBar } from 'components/page/nav-bar'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'
import { useProfilePercentage } from 'hooks/use-profile-percentage/useProfilePercentage'
import { JobsFilterDrawer } from './components/JobsFilterDrawer'
import { MainWrapper } from 'components/page/containers/MainWrapper'
import { PaginatedContent } from 'common/page-utilities/PaginatedContent'
import { JobProps } from 'common/types'

const PrivateTestWrapper = () => {
  const { backendUser } = useAuth()
  const { isDevice } = useScreenSizes()
  const [jobDrawer, setJobDrawer] = useState(false)
  const theme = useTheme()
  const { inviteUsersByEmail } = useOnboarding()
  const { fetchingJobs, jobs, fetchMoreMemberJobs, lastResponse, filter, setFilter } = useJobsFeed(10)

  const hasFilters = !!Object.keys(filter)?.length || false
  const hasJobs = !!jobs?.length || false

  return (
    <>
      <MainWrapper
        inviteUsersByEmail={inviteUsersByEmail}
        nopadding
        hideHeader={!backendUser ? true : false}
        stickTopBar={backendUser ? true : false}
        title="Private Test"
        user={backendUser}
        showAvatar={backendUser ? true : false}
        hideFooter={!backendUser && isDevice ? true : false}
        showSearch={isDevice ? true : true}
      >
        <PrivateJobHeader mt="0" isDevice={isDevice}>
          <PrivateJobLeftContainer>
            <PrivateJobTitle>
              <PrivateJobTitleInner
                onClick={() => {
                  history.back()
                }}
              >
                {backendUser ? <ArrowBack style={{ marginRight: '0.52rem' }} /> : ''} List of jobs
              </PrivateJobTitleInner>
            </PrivateJobTitle>
          </PrivateJobLeftContainer>
          <PrivateJobMiddleContainer>
            <SearchInput setFilter={setFilter} filter={filter} />
          </PrivateJobMiddleContainer>

          <PrivateJobRightContainer>
            <FilterButton
              onClick={() => {
                setJobDrawer(true)
              }}
            />
          </PrivateJobRightContainer>
        </PrivateJobHeader>
        <PaginatedContent
          endpoint="/job/search"
          height="100%"
          renderFunction={(item: JobProps) => (
            <Box color="white" height="152px">
              {item?.title}
            </Box>
          )}
          searchParams={{
            page: 1,
            pageSize: 10,
            dir: 'desc',
            sort: 'created_at'
          }}
          endpointSpecificSearchParams={filter}
          noMoreItemsText="No more Jobs"
          nothingFoundText="No Jobs found"
        />
      </MainWrapper>
      <JobsFilterDrawer isDrawerOpen={jobDrawer} setIsDrawerOpen={setJobDrawer} filter={filter} setFilter={setFilter} />
    </>
  )
}

export default PrivateTestWrapper
